import { healingLines } from "@/mocks/quotes";
import { useCopy } from "@/hooks/useCopy";

export default function HealingLines() {
  const { copiedId, copy } = useCopy();

  return (
    <section id="lines" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-16">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div className="max-w-2xl">
            <span className="text-xs tracking-widest text-secondary-700 uppercase">Healing Lines</span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
              治愈系短句，一句话就够
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              不想读长段落的时候，就从这里挑一句带走。点击卡片右侧的复制按钮，
              短句会直接进你的剪贴板，粘到朋友圈或备忘录都很方便。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {healingLines.map((line) => {
            const isCopied = copiedId === line.id;
            return (
              <div
                key={line.id}
                className="relative flex flex-col justify-between rounded-lg bg-background-50 border border-background-200/70 p-6 hover:border-accent-300 transition-colors"
              >
                <p className="font-heading text-base md:text-lg leading-loose text-foreground-900 pr-10">
                  {line.text}
                </p>
                <div className="mt-5 flex items-end justify-between gap-3">
                  <p className="text-xs text-foreground-500 leading-relaxed">{line.note}</p>
                  <button
                    type="button"
                    onClick={() => copy(line.id, line.text)}
                    aria-label={`复制短句：${line.text}`}
                    className={`shrink-0 w-9 h-9 flex items-center justify-center rounded-md border transition-colors cursor-pointer ${
                      isCopied
                        ? "bg-accent-500 border-accent-500 text-background-50"
                        : "border-background-300 text-foreground-600 hover:bg-accent-100 hover:text-accent-900"
                    }`}
                  >
                    <i className={isCopied ? "ri-check-line" : "ri-file-copy-line"}></i>
                  </button>
                </div>
                {isCopied && (
                  <span className="absolute -top-3 right-5 px-3 py-1 rounded-full bg-foreground-950 text-background-50 text-xs">
                    已复制
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}